import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { _post } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const TransactionCategoriesList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('transaction_categories'), link: '/transaction-categories-list' },
		{ title: t('list') }
	];

	const [transactionCategories, setTransactionCategories] = useState([]);
	let transactionCategoriesListData = {
		head: [t('title'), t('type')],
		body: transactionCategories.map(transactionCategory => [
			transactionCategory.transactioncategory_name,
			<span className={"badge rounded-pill p-2 badge-subtle-" + (transactionCategory.is_active ? 'success' : 'secondary')}>
				{transactionCategory.is_active ? t('active') : t('deactive')}
			</span>,
			// transactionCategory.transactioncategory_information.no_edit ? '' :
			// 	<Link className='btn btn-secondary btn-sm p-1' to={`/transaction-categories-edit/${transactionCategory.transactioncategory_id}`}>
			// 		<i className="fa fa-edit"></i> {t('edit')}
			// 	</Link>
		]),
		directions: ['rtl', '']
	};
	
	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchTransactionCategoryTitle, setSearchTransactionCategoryTitle] = useState(null);
	const [searchTransactionCategoryType, setSearchTransactionCategoryType] = useState(null);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getUserCategories = async () => {
		let body = {
			transactioncategory_name: searchTransactionCategoryTitle,
			transactioncategory_type: searchTransactionCategoryType,
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/transactioncategories/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_transactioncategories);
				setTransactionCategories(response.data.transactioncategories);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	const filterTransactionCategories = event => {
		event.preventDefault();
		if(searchButtonIsLoading)
			return 0;
		let title = event.target.searchTransactionCategoryTitle.value.trim() || null;
		let type = event.target.searchTransactionType.value.trim() || null;
		setSearchTransactionCategoryTitle(title);
		setSearchTransactionCategoryType(type);
		if(pageNumber === 1)
			setSearchCounter(searchCounter + 1);
		else
			setPageNumber(1);
	};
	
	const transactionCategoryTypesList = [
		{ key: t('positive'), value: 1 },
		{ key: t('negative'), value: 2 }
	];
	
	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getUserCategories();
	}, [searchCounter]);

	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('search_for')} {t('transaction_categories')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={filterTransactionCategories}>
						<div className="row gx-2">
							<FormField fieldKey="searchTransactionCategoryTitle" title={t('title')} value={searchTransactionCategoryTitle} isSearch={true} />
							<FormField type="select" fieldKey="searchTransactionCategoryType" title={t('type')} value={searchTransactionCategoryType} selectItems={transactionCategoryTypesList} isSearch={true} />
						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={searchButtonIsLoading}>
								<i className="fa fa-search"></i> {t('search')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
			<ListTable title={t('transaction_categories')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={transactionCategoriesListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default TransactionCategoriesList;
